import React, {Fragment} from 'react';
import {Formatted, Video, Quote} from 'components';
import {config} from 'helpers';

export function Dreams() {
  return (
    <Fragment>
      <Formatted className="medium-spacing">
        <Video.Video src={config.videos.identity.dreams} />
        <div className="medium-spacing">
          <p>Dreams are inspirational thoughts and images of a desired future.</p>
          <p>The dictionary defines a dream as an aspiration, goal, or aim. These are powerful words of action and purpose. Having dreams energizes and empowers us to take action and do our best to achieve them.</p>
          <p>Some people speak about dreams with a wistful longing in their voice, convinced that something is "only a dream". If you believe your dream won't come true, it won't. But dreams do come true. Identifying and declaring what you want will determine what you get and shape your future. Before anything happens in the real world, it must first be imagined and visualized in your mind, and that is how dreams become the engine that takes you where you want to go. If you don't pursue your dreams now, you may one day realize that your life has slipped away.</p>
        </div>
      </Formatted>
      <Quote author="John C. Maxwell">
        The greatest reward of pursuing a dream is who you become as a result.
      </Quote>
    </Fragment>
  );
}
